<template>
  <VPopup
    :target="target"
    :visible="true"
    show-pointer
    position="left"
    :css-classes="['deferred-payment-popup']"
    padding="10px"
  >
    <section>
      <dl>
        <dt>Стандартная отсрочка</dt>
        <dd>{{ bid.tender.desiredPaymentTerm?.stringRepresentation || '--' }}</dd>

        <dt>Желаемая дата</dt>
        <dd>{{ bid.plannedPaymentDateByBuyer?.format() ?? '--' }}</dd>
      </dl>

      <dl>
        <dt v-if="$core.currentPartner.isSeller === true">Моя отсрочка</dt>
        <dt v-else>Отсрочка поставщика</dt>
        <dd>{{ bid.paymentTerm?.stringRepresentation || '--' }}</dd>

        <dt>Выбранная дата</dt>
        <dd>{{ bid.plannedPaymentDateToSeller?.format() ?? '--' }}</dd>
      </dl>

      <dl>
        <dt>Разница</dt>
        <dd>{{ bid.daysBetween }} {{ $core.utils.regional.ru.pluralize(bid.daysBetween, 'день', 'дня', 'дней') }}</dd>
      </dl>

      <dl>
        <dt>Стоимость кредита в день</dt>
        <dd>{{ $core.utils.number.numberFormat(bid.dailyBankRate, 2) }}%</dd>
      </dl>

      <dl>
        <dt>Кредитная наценка</dt>
        <dd>{{ bid.priceModDeferredPayment }}</dd>
      </dl>
    </section>

    <VHelperText class="deferred-description">
      Если ваша отсрочка меньше стандартной, то за каждый день разницы добавляется кредитная
      наценка + {{ $core.utils.number.numberFormat(bid.dailyBankRate, 2) }}%
    </VHelperText>
  </VPopup>
</template>

<style src="./DeferredPaymentPopup.scss" />

<script lang="ts">

import type TenderBid from '@/domains/TenderBids/TenderBid';

export default defineComponent({
  name: 'DeferredPaymentPopup',

  props: {
    /** Ставка целиком: попап показывает её условия оплаты и наценку. */
    bid: {
      type:     Object as PropType<TenderBid>,
      required: true,
    },

    /** Элемент, у которого рисуется попап. */
    target: {
      type:    HTMLElement,
      default: null,
    },
  },
});
</script>
